import clsx from 'clsx';
import { Container } from "../../components/atoms/Container";
import {
    WhatsAppIcon,
    InstagramIcon,
    FacebookIcon,
    TwitterIcon,
} from '../../components/atoms/Icons';
import portraitImage from '../../assets/images/photos/imageAbout.jpg';
import { ReactNode } from 'react';
import { Header } from '../../components/atoms/Header';

interface IIcon {
    className?: string;
    href?: string;
    children?: ReactNode;
    Icon?: any;
}

function SocialLink({ className, href, children, Icon }: IIcon) {
    return (
        <li className={clsx(className, 'flex')}>
            <a
                href={href}
                className="group flex text-sm font-medium text-zinc-800 transition hover:text-orange-800 dark:text-zinc-200 dark:hover:text-orange-800"
            >
                <Icon className="h-6 w-6 fill-black-900 dark:fill-zinc-400 cursor-pointer transition group-hover:fill-orange-800  dark:group-hover:fill-orange-800" />
                <span className="ml-4">{children}</span>
            </a>
        </li>
    )
}

function MailIcon(props: IIcon) {
    return (
        <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>
            <path
                fillRule="evenodd"
                d="M6 5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H6Zm.245 2.187a.75.75 0 0 0-.99 1.126l6.25 5.5a.75.75 0 0 0 .99 0l6.25-5.5a.75.75 0 0 0-.99-1.126L12 12.251 6.245 7.187Z"
            />
        </svg>
    )
}

export default function About() {
    return (
        <>
            <Header />
            <Container className="mt-16 sm:mt-32">
                <div className="grid grid-cols-1 gap-y-16 lg:grid-cols-2 lg:grid-rows-[auto_1fr] lg:gap-y-12">
                    <div className="lg:pl-20">
                        <div className="max-w-xs px-2.5 lg:max-w-none">
                            <img
                                src={portraitImage}
                                alt=""
                                sizes="(min-width: 1024px) 32rem, 20rem"
                                className="aspect-square rotate-3 h-80 w-80 rounded-2xl bg-zinc-100 object-cover dark:bg-zinc-800"
                            />
                        </div>
                    </div>
                    <div className="lg:order-first lg:row-span-2">
                        <h1 className="text-4xl font-bold tracking-tight text-zinc-800 dark:text-zinc-100 sm:text-4xl">
                            "Experiencia culinaria única:
                            Bienvenido a Aceña,
                            la panadería que fusiona
                            lo antiguo con lo moderno"
                        </h1>
                        <div className="mt-6 space-y-7 text-base dark:text-white text-gray-900">
                            <p>
                                "Déjate llevar por el aroma a pan recién horneado y sumérgete en el
                                mundo de Aceña, la panadería que ha revolucionado el arte de la
                                elaboración de pan. Fundada en 2014, Aceña es el resultado de la
                                fusión perfecta entre lo antiguo y lo moderno, como un molino
                                harinero de agua situado en el cauce de un río que muele los
                                ingredientes más frescos y finos para ofrecerte un sabor único y
                                auténtico
                            </p>
                            <p>
                                Cada local de Aceña es un espacio único, donde la arquitectura rústica
                                se mezcla con la modernidad para crear un ambiente acogedor y lleno
                                de personalidad. Aquí, el arte de la panadería se combina con el
                                diseño para ofrecerte una experiencia culinaria única. Ven y déjate
                                conquistar por el sabor, el aroma y la belleza de Aceña."
                            </p>
                        </div>
                    </div>
                    <div className="lg:pl-20">
                        <ul role="list">
                            <SocialLink href="https://www.facebook.com/acenacuba" Icon={FacebookIcon} >
                                Síguenos en Facebook
                            </SocialLink>
                            <SocialLink href="https://www.instagram.com/acenacuba/" Icon={InstagramIcon} className="mt-4">
                                Síguenos en Instagram
                            </SocialLink>                           
                            <SocialLink
                                Icon={WhatsAppIcon}
                                className="mt-8 border-t border-zinc-100 pt-8"
                            >
                                +53 56004750
                            </SocialLink>
                            <SocialLink
                                Icon={WhatsAppIcon}
                                className="mt-4"
                            >
                                +53 50288075
                            </SocialLink>
                            <SocialLink
                                href="mailto:info@grupoacena.com"
                                Icon={MailIcon}
                                className="mt-4">
                                atencionalcliente@grupoacena.com
                            </SocialLink>
                        </ul>
                    </div>
                </div>
            </Container>
        </>
    )
}
